import React, { useState } from "react";
import "./styles.css";

import { useRef } from "react";
import Header from "../../Common/Header";
import Footer from "../../Common/Footer";

import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../../Context/Context";
import { use, useContext, useEffect } from "react";
import {
  getRecords,
  PostRecords,
  uploadMultipleFiles,
} from "../../Services/ApiCall";
import FeaturedProperty from "../../Common/FeaturedProperties";
import ProjectsComp from "../../Common/Projects";
import NearByProperties from "../../Common/NearByProperties";
import {
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  BaseUrl,
  apiUrl_dialerp,
  setLogindata,
  setUserdata,
} from "../../Services/Urls";
import FilterParams from "../../Classes/FilterParams";
import { useNavigate } from "react-router-dom";

import { TailSpin } from "react-loader-spinner";
import SelectDialog from "../../Common/SelectDialog ";
import AmenitiesDialog from "../../Common/AmenitiesDialog";
import { decryptOtp, getDisplayPrice } from "../../Services/Helper";
import {
  callApi,
  makeApiRequest,
  callAzureOpenAI,
} from "../../Services/ApiService";

import { toast } from "react-toastify";
import SucessDialog from "../../Common/Dialog/SucessDialog";
import {
  formatIndianAmount,
  removeSpecialCharacters,
} from "../../Services/Helper";

const properties = [
  {
    title: "3 BHK Apartment in Andheri West",
    location: "Andheri West, Mumbai",
    price: "₹2.8 Cr",
    views: 342,
    image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2",
  },
  {
    title: "2 BHK Flat in Powai",
    location: "Powai, Mumbai",
    price: "₹1.65 Cr",
    views: 218,
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    title: "4 BHK Villa in Lonavala",
    location: "Lonavala, Pune",
    price: "₹3.5 Cr",
    views: 567,
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
  },
];

export default function CreateCampaign() {
  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    CityData,

    coordinates,

    Locality,

    Area,
  } = useContext(ApiContext);
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [selected, setSelected] = useState(null);
  const [campaignName, setCampaignName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setloading] = useState(false);

  const [walletData, setwalletData] = useState(null);
  const [budget, setBudget] = useState(1000);

  const costPerImpression = 1.4;

  const quickBudgets = [500, 1000, 2500, 5000];

  const [MyListing, setMyListing] = useState([]);

  const [loader, setLoader] = useState(false);

  useEffect(() => {
    getMyListingData();
    getwalletdetails();
  }, []);

  const getwalletdetails = () => {
    const filter = `{UserID: { $in: [${LoggedInUserID}] }}`;

    getRecords(437, 1, filter, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setwalletData(data?.response?.records[0] || null);
          setloading(false);
        } else {
          setwalletData(null);
          setloading(false);
          console.log("Error in fetching featured properties", data);
        }
      } else {
        setloading(false);
      }
    });
  };

  const getMyListingData = () => {
    const filter = `{'FeaturedID':{\$eq:${2}},'StatusID':{\$eq:${2}},'cByID':{\$eq:${LoggedInUserID}}}`;
    getRecords(384, 1000, filter, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false) {
          setMyListing(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const LaunchCampaign = () => {
    let CampaignID = null;
    const body = [
      {
        Campaign: campaignName,
        PropertyType: selected?.PropertyType,
        PropertyTypeID: selected?.PropertyTypeID,
        Vertical: selected?.Vertical,
        VerticalID: selected?.VerticalID,
        ListingID: selected?.ListingID,
        Listing: selected?.Title,
        CostPerImpression: 1.4,
        Budget: totalBudget,
        SpentAmount: 0.0,
        TotalImpressions: 0,
        StartDate: startDate,
        EndDate: endDate,
        TotalViews: 0,
        TotalLeads: 0,
        LastServedAt: "",
        User: LoggedInUserName,
        UserID: LoggedInUserID,
        Status: "Active",
        StatusID: 1,
        Society: selected?.Society,
        SocietyID: selected?.SocietyID,
        City: selected?.City,
        CityID: selected?.CityID,
        Locality: selected?.Locality,
        LocalityID: selected?.LocalityID,
        State: selected?.State,
        Country: selected?.Country,
        Images: selected?.Images,
        Title: selected?.Title,
        DailyBudget : budget,
        TodaySpent : 0.0 ,
      },
    ];

    if (walletData?.Balance < totalBudget) {
      toast.error("Insufficient wallet Balance");
      navigate("/wallet");
    } else {
      PostRecords(431, 1, body, (data) => {
        if (data != null && data?.response?.hasErrors === false) {
          CampaignID = data?.response?.response?.clientID;
          const updatebody = [
            {
              ListingID: selected?.ListingID,
              FeaturedID: 1,
              Featured: "Y",
            },
          ];

          PostRecords(384, 1, updatebody, (data) => {
            if (data != null && data?.response?.hasErrors === false) {
              //   toast.success(`${"Campaign Launched Successfully"}`);

              // setStep(1);
              // getMyListingData();
              // setShowModal(true);

              const walletbody = [
                {
                  WalletID: walletData?.WalletID,

                  Balance:
                    parseFloat(walletData?.Balance || "0") -
                    parseFloat(totalBudget || "0"),
                  TotalDebited:
                    parseFloat(walletData?.TotalDebited || "0") +
                    parseFloat(totalBudget || "0"),
                },
              ];

              PostRecords(437, 1, walletbody, (data) => {
                if (data != null && data?.response?.hasErrors === false) {
                  const TransationBody = [
                    {
                      User: userData?.User,
                      UserID: userData?.UserID,
                      Amount: totalBudget,
                      BalanceAfter:
                        parseFloat(walletData?.Balance || "0") -
                        parseFloat(totalBudget || "0"),
                      CampaignID: CampaignID || 0,
                      Campaign: campaignName || "",
                    },
                  ];

                  PostRecords(438, 1, TransationBody, (data) => {
                    if (data != null && data?.response?.hasErrors === false) {
                      toast.success(`${"Campaign Launched Successfully"}`);

                      setStep(1);
                      getMyListingData();
                      getwalletdetails();
                      setShowModal(true);
                    } else {
                      toast.error(`${data?.response?.errors}`);
                    }
                  });
                } else {
                  toast.error(`${data?.response?.errors}`);
                }
              });
            } else {
              toast.error(`${data?.response?.errors}`);
            }
          });
        } else {
          toast.error(`${data?.response?.errors}`);
        }
      });
    }
  };

  const formatDate = (date) =>
    new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date);

  const calculateDays = (start, end) => {
    if (!start || !end) return 0;

    const s = new Date(start);
    const e = new Date(end);

    const diffTime = e - s;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    return diffDays >= 0 ? diffDays + 1 : 0; // +1 to include start day
  };

  const totalDays = calculateDays(startDate, endDate);
  const totalBudget = totalDays * Number(budget || 0);

  const impressions = Math.round(totalBudget / costPerImpression);
  return (
    <div className="campaign-container">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <span className="light">LandPanda Ads</span>
        <span className="arrow">›</span>
        <span className="bold">Create Campaign</span>
      </div>

      {/* STEP HEADER */}
      <div className="step-header">
        {[1, 2, 3, 4].map((s, i) => (
          <div key={s} className="step-wrapper">
            <div
              className={`step-circle 
            ${step === s ? "active" : ""}
            ${step > s ? "complete" : ""}`}
            >
              {step > s ? "✓" : s}
            </div>

            {i < 3 && (
              <div
                className={`step-line ${step > s ? "line-active" : ""}`}
              ></div>
            )}
          </div>
        ))}
      </div>

      {/* STEP 1 */}
      {step === 1 && (
        <>
          <h2>Select Property to Boost</h2>
          <p className="subtitle">
            Choose from your active listings with no ongoing campaign
          </p>

          <div className="property-grid">
            {MyListing?.map((p, i) => {
              const defaultImage = "assets/img/property/property-22.jpg";

              const imageSrc =
                typeof p?.Images === "string" && p?.Images.trim() !== ""
                  ? p?.Images.split(",")[0].trim()
                  : defaultImage;
              return (
                <>
                  <div
                    key={i}
                    className={`adscard property-card ${selected?.title === p.title ? "selected" : ""}`}
                    onClick={() => {
                      if (walletData == null) {
                        toast.error(
                          "You need to add funds to your wallet to launch a campaign",
                        );
                        navigate("/wallet");
                      } else {
                        setSelected(p);
                        setStep(2);
                      }
                    }}
                  >
                    <div className="image-box">
                      <img src={imageSrc} alt="" />
                      <span className="live-badge">Live</span>
                    </div>

                    <div className="card-body">
                      <h3>{p.Title}</h3>
                      <p className="location">
                        <i class="ri-map-pin-line"></i> {p.Locality}
                      </p>

                      <div className="price-row">
                        <span className="price">{getDisplayPrice(p)}</span>
                        {/* <span className="views">{p.views} views</span> */}
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
          {/* 
        <button
          className="primary-btn"
          disabled={!selected}
         
        >
          Continue
        </button> */}
        </>
      )}

      {/* STEP 2 */}
      {step === 2 && (
        <>
          <h2>Name Your Campaign</h2>
          <p className="subtitle">
            Choose a memorable name to track this campaign
          </p>

          <div className="c-card">
            <div className="campaign-card">
              <img
                src={
                  typeof selected?.Images === "string" &&
                  selected?.Images.trim() !== ""
                    ? selected?.Images.split(",")[0].trim()
                    : "assets/img/property/property-22.jpg"
                }
                alt=""
              />

              <div>
                <h3>{selected.Title}</h3>
                <p style={{ marginBottom: "4px" }}>
                  <i class="ri-map-pin-line"></i> {selected.Locality}
                </p>
                <span className="price">{getDisplayPrice(selected)}</span>
              </div>
            </div>

            <h6>Campaign Name</h6>
            <input
              type="text"
              className="text-input"
              placeholder="Campaign Name"
              value={campaignName}
              onChange={(e) => setCampaignName(e.target.value)}
            />
          </div>

          <div className="nav">
            <button className="back-btn" onClick={() => setStep(1)}>
              <i class="ri-arrow-left-line"></i> Back
            </button>
            <button
              className="primary-btn"
              disabled={!campaignName}
              onClick={() => setStep(3)}
              style={{
                backgroundColor: !campaignName ? "lightgrey" : "",
                color: "#fff",
              }}
            >
              Continue <i class="ri-arrow-right-line"></i>
            </button>
          </div>
        </>
      )}

      {/* STEP 3 */}
      {step === 3 && (
        <>
          <h2>Set Your Dialy Budget & Schedule</h2>
          <p className="subtitle">
            Choose how much you want to spend and when to run this campaign
          </p>

          <div className="budget-wrapper">
            {/* Budget Card */}

            <div className="budget-card">
              <p className="section-title">Quick Select</p>

              <div className="quick-select">
                {quickBudgets.map((b) => (
                  <button
                    key={b}
                    className={`quick-btn ${budget === b ? "active" : ""}`}
                    onClick={() => setBudget(b)}
                  >
                    ₹{b.toLocaleString()}
                  </button>
                ))}
              </div>

              <h6>Daily Budget</h6>

              <input
                type="text"
                className="text-input"
                placeholder="Enter your daily budget"
                value={budget}
                onChange={(e) => setBudget(e.target.value)}
              />

              <div className="custom-budget">
                <div className="budget-row">
                  <p>Custom Daily Budget</p>

                  <h3>₹{budget.toLocaleString()}</h3>
                </div>

                <input
                  type="range"
                  min="100"
                  max="10000"
                  value={budget}
                  onChange={(e) => setBudget(e.target.value)}
                  className="slider"
                />

                <div className="range-labels">
                  <span>₹100</span>
                  <span>₹10,000</span>
                </div>
              </div>

              {/* Cost Box */}
            </div>

            {/* Schedule */}

            <div className="schedule-card">
              <h4>Campaign Schedule</h4>
              <p className="subtitle-small">
                Select the start and end dates for your campaign
              </p>

              <div className="date-grid">
                <div className="date-field">
                  <label>Start Date</label>
                  <input
                    onChange={(e) => {
                      setStartDate(formatDate(new Date(e.target.value)));
                    }}
                    type="date"
                  />
                </div>

                <div className="date-field">
                  <label>End Date</label>
                  <input
                    onChange={(e) => {
                      setEndDate(formatDate(new Date(e.target.value)));
                    }}
                    type="date"
                  />
                  <p className="hint">Select a start date first</p>
                </div>
              </div>
              <div className="cost-box">
                <div className="cost-left">
                  <p>Cost per Impression</p>
                  <p>Total Days</p>
                    <p>Total Budget</p>
                  <strong>Estimated Impressions</strong>
                </div>

                <div className="cost-right">
                  <p style={{ color: "#000" }}>
                    ₹{costPerImpression.toFixed(2)}
                  </p>
                  <p style={{ color: "#000" }}>
                    {totalDays ? `${totalDays} days` : "0 days"}
                  </p>
                  <p style={{ color: "#000" }}>
                    ₹{totalBudget.toFixed(2)}
                  </p>
                  <strong>~{impressions}</strong>
                </div>
              </div>
            </div>

            {/* Budget Examples */}
            <h6>Budget Examples</h6>
            <div className="examples">
              <div>
                ₹100
                <span>~71 impressions</span>
              </div>

              <div>
                ₹500
                <span>~357 impressions</span>
              </div>

              <div>
                ₹1,000
                <span>~714 impressions</span>
              </div>

              <div>
                ₹5,000
                <span>~3,571 impressions</span>
              </div>

              <div>
                ₹10,000
                <span>~7,142 impressions</span>
              </div>
            </div>
          </div>

          <div className="nav">
            <button className="back-btn" onClick={() => setStep(2)}>
              <i class="ri-arrow-left-line"></i> Back
            </button>
            <button disabled={!budget || !startDate || !endDate} className="primary-btn"  style={{
                backgroundColor: !budget || !startDate || !endDate ? "lightgrey" : "",
                color: "#fff",
              }} onClick={() => {

                if(walletData?.Balance < totalBudget){
                  toast.error("Insufficient Balance, please add funds to your wallet")
                }else{
                  setStep(4)
                }
                
                
                
                }}>
              Continue <i class="ri-arrow-right-line"></i>
            </button>
          </div>
        </>
      )}

      {/* STEP 4 */}
      {step === 4 && (
        <>
          {" "}
          <h2>Review & Launch Campaign</h2>
          <p className="subtitle">
            {" "}
            Confirm your campaign details before launching{" "}
          </p>
          <div className="review-card">
            <p className="section-title">Selected Property</p>
            <div className="property-preview">
              <img
                src={
                  typeof selected?.Images === "string" &&
                  selected?.Images.trim() !== ""
                    ? selected?.Images.split(",")[0].trim()
                    : "assets/img/property/property-22.jpg"
                }
                alt=""
              />
              <div>
                <h3>{selected.Title}</h3>
                <p className="location" style={{ marginBottom: 4 }}>
                  <i class="ri-map-pin-line"></i> {selected.location}{" "}
                </p>
                <span className="price">{getDisplayPrice(selected)}</span>
              </div>
            </div>
          </div>
          <div className="review-card" style={{ background: "transparent" }}>
            <p className="section-title">Campaign Details</p>
            <div className="details-grid">
              {" "}
              <span>Campaign Name</span> <strong>{campaignName}</strong>{" "}
              <span>Cost per Impression</span>{" "}
              <strong>₹{costPerImpression}</strong>
              <span>Daily Budget</span> <strong>₹{budget}</strong>
              <span>Start Date</span> <strong>{startDate || "-"}</strong>
              <span>End Date</span> <strong>{endDate || "-"}</strong>{" "}
              <span>Total Days</span>{" "}
              <strong>{`${totalDays} Days` || "-"}</strong>{" "}
              <span>Total Budget</span>{" "}
              <strong>₹{totalBudget || "-"}</strong>{" "}
            </div>
            <div className="impressions-row">
              {" "}
              <span>Estimated Impressions</span>{" "}
              <strong className="impressions"> ~{impressions} </strong>{" "}
            </div>

            <div class="listing-section">
              <h3 class="section-title">Your Listing Will Appear In</h3>

              <div class="listing-grid">
                <div class="listing-item">
                  <i class="ri-search-line"></i>
                  <span>Search Top Results</span>
                </div>

                <div class="listing-item">
                  <i class="ri-star-line"></i>
                  <span>Featured Section</span>
                </div>

                <div class="listing-item">
                  <i class="ri-thumb-up-line"></i>
                  <span>Buyer Recommendations</span>
                </div>

                <div class="listing-item">
                  <i class="ri-notification-3-line"></i>
                  <span>Buyer Alerts</span>
                </div>
              </div>
            </div>

            <div class="info-box">
              <div class="info-header">
                <i class="ri-information-line"></i>
                <span>Important Information</span>
              </div>

              <p>
                Campaign runs until budget is exhausted. You can pause or resume
                anytime from the Ongoing Campaigns tab.
              </p>
            </div>
          </div>
          <div className="nav">
            {" "}
            <button className="back-btn" onClick={() => setStep(3)}>
              {" "}
              ← Back{" "}
            </button>{" "}
            <button className="primary-btn" onClick={() => LaunchCampaign()}>
              <i class="ri-rocket-line"></i> Launch Campaign{" "}
            </button>{" "}
          </div>
        </>
      )}

      {/* SUCCESS MODAL */}
      {showModal && (
        <div class="campaign-overlay">
          <div class="campaign-modal">
            <div class="success-icon">
              <i class="ri-rocket-line"></i>
            </div>

            <h2 class="title">Campaign Launched!</h2>

            <p class="subtitle">
              Your campaign "Campaign Name" is now live. You can track it in the
              Ongoing Campaigns tab.
            </p>

            <div class="divider"></div>

            {/* <div class="details">

      <div class="row">
        <span>Campaign Name</span>
        <strong>test</strong>
      </div>

      <div class="row">
        <span>Budget</span>
        <strong>₹500</strong>
      </div>

      <div class="row">
        <span>Estimated Impressions</span>
        <strong class="green">~357</strong>
      </div>

      <div class="row">
        <span>Duration</span>
        <strong>5 days</strong>
      </div>

    </div> */}

            <button
              class="primary-btn"
              onClick={() => {
                setShowModal(false);
                setStep(1);
              }}
            >
              Got It
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
